import { PartiesService } from './../service/parties.service';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PartyContactMechanisms } from '../model/party-contact-mechanisms.model';

export class partyContactMechanismInterface {
    emails!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
    postalAddresses!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
    phoneNumbers!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
    contactPersons!: { title: string; header: string; enabled: boolean; current: PartyContactMechanisms[]; past: PartyContactMechanisms[] };
}

@Component({
    selector: 'view-party-contact-mechanism-inline',
    templateUrl: './view-party-contact-mechanism-inline.component.html',
    styleUrl: './view-party-contact-mechanism-inline.component.scss'
})
export class ViewPartyContactMechanismInlineComponent implements OnInit, OnChanges {
    @Input() party!: any;
    @Input() category!: string;
    @Input() disableRefresh = false;
    @Input() inLine = false;

    loading = false;

    partyContactMechanisms: any[] = [];

    postalAddresses: any[] = [];
    emails: any[] = [];
    telephoneNumbers: any[] = [];

    constructor(private partiesService: PartiesService) {}

    ngOnInit(): void {
        this.init();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['party'] && !this.disableRefresh) {
            this.getPartyContactMechanisms();
        }

        if (changes['party'] && this.disableRefresh && this.party) {
            this.filterFromParty();
        }
    }

    private init(): void {
        if (this.disableRefresh && this.party) {
            this.filterFromParty();
        } else if (this.party) {
            this.getPartyContactMechanisms();
        }
    }

    private getPartyContactMechanisms(): void {
        if (!this.party?.ID) {
            return;
        }

        this.loading = true;

        this.partiesService.getPartyContactMechanisms(this.party.ID, this.category).subscribe({
            next: (res: any) => {
                if (res?.msg?.SUCCESS === false) {
                    this.partyContactMechanisms = [];
                } else if (res?.partyContactMechanisms) {
                    console.log('Party Contact Mechanisms', res.partyContactMechanisms);
                    this.partyContactMechanisms = res.partyContactMechanisms;
                }

                this.buildPartyContactMechanisms();
                this.loading = false;
            },
            error: (err) => {
                console.error(err);
                this.loading = false;
            }
        });
    }

    private filterFromParty(): void {
        this.partyContactMechanisms =
            this.party?.PARTY_CONTACT_MECHANISMS?.filter((pcm: any) => pcm.CONTACT_MECHANISMS.CONTACT_MECHANISM_TYPES.TYPE === this.category) ?? [];

        this.buildPartyContactMechanisms();
    }

    private buildPartyContactMechanisms(): void {
        this.postalAddresses = [];
        this.emails = [];
        this.telephoneNumbers = [];

        for (const pcm of this.partyContactMechanisms) {
            switch (pcm.CONTACT_MECHANISMS.CONTACT_MECHANISM_TYPES.TYPE) {
                case 'Address':
                    this.postalAddresses.push(pcm);
                    break;
                case 'Email':
                    this.emails.push(pcm);
                    break;
                case 'Phone':
                    this.telephoneNumbers.push(pcm);
                    break;
            }
        }
    }

    hasPostalAddresses(): boolean {
        return this.postalAddresses.length > 0;
    }

    hasEmails(): boolean {
        return this.emails.length > 0;
    }

    hasTelephoneNumbers(): boolean {
        return this.telephoneNumbers.length > 0;
    }

    checkCategory(category: string): boolean {
        return this.category ? this.category === category : true;
    }
}
